// src/hooks/useFileUpload.js
import { useState } from 'react';

export const useFileUpload = (onFileAnalyzed) => {
  const [isDragging, setIsDragging] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    setIsDragging(false);

    const files = e.dataTransfer.files;
    if (files.length === 0) return;

    const file = files[0];
    console.log('📤 File dropped:', file.name);

    setIsProcessing(true);

    try {
      const formData = new FormData();
      formData.append('file', file);

      // Get or create sessionId to match chat session
  let sessionId = localStorage.getItem('chatSessionId');
  if (!sessionId) {
    sessionId = 'session-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
    localStorage.setItem('chatSessionId', sessionId);
  }
  
  // Add session info to upload
  formData.append('sessionId', sessionId);
  formData.append('companyId', 'Markham Investigation & Protection');
  
  console.log('🔄 Uploading to /api/analyze-file with sessionId:', sessionId);

      const response = await fetch('/api/analyze-file', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        throw new Error(`Upload failed: ${response.status}`);
      }

      const result = await response.json();
      console.log('✅ File analysis complete:', result);
      console.log('📊 Full result structure:', JSON.stringify(result, null, 2));

      if (onFileAnalyzed) {
        console.log('📤 Calling onFileAnalyzed with result');
        onFileAnalyzed(result);
      } else {
        console.log('⚠️ No onFileAnalyzed callback provided');
      }

    } catch (error) {
      console.error('❌ File upload error:', error);
      alert('File analysis failed: ' + error.message);
    } finally {
      setIsProcessing(false);
    }
  };

  return {
    isDragging,
    isProcessing,
    handleDragOver,
    handleDragLeave,
    handleDrop
  };
};
